import api from './api';

export const fetchAffiliateSettings = async () => {
  const response = await api.get('/admin/affiliate/settings/');
  return response.data;
};

export const updateAffiliateSettings = async (payload) => {
  const response = await api.put('/admin/affiliate/settings/1/', payload);
  return response.data;
};

export const fetchAffiliatePartners = async (params = {}) => {
  const response = await api.get('/admin/affiliate/partners/', { params });
  return response.data;
};

export const fetchAffiliateRewards = async (params = {}) => {
  const response = await api.get('/admin/affiliate/rewards/', { params });
  return response.data;
};

export const fetchAffiliateRankings = async (params = {}) => {
  const response = await api.get('/admin/affiliate/rankings/', { params });
  return response.data;
};

// New API functions for affiliate management
export const suspendAffiliate = async (affiliateId) => {
  const response = await api.post(`/admin/affiliate/partners/${affiliateId}/suspend/`);
  return response.data;
};

export const activateAffiliate = async (affiliateId) => {
  const response = await api.post(`/admin/affiliate/partners/${affiliateId}/activate/`);
  return response.data;
};

export const updateAffiliateCommission = async (affiliateId, commissionPercentage) => {
  const response = await api.post(`/admin/affiliate/partners/${affiliateId}/update_commission/`, {
    commission_percentage: commissionPercentage,
  });
  return response.data;
};

export const bulkSuspendAffiliates = async (affiliateIds) => {
  const response = await api.post('/admin/affiliate/partners/bulk_suspend/', {
    affiliate_ids: affiliateIds,
  });
  return response.data;
};

export const bulkActivateAffiliates = async (affiliateIds) => {
  const response = await api.post('/admin/affiliate/partners/bulk_activate/', {
    affiliate_ids: affiliateIds,
  });
  return response.data;
};

export const fetchAffiliateStatistics = async () => {
  const response = await api.get('/admin/affiliate/partners/statistics/');
  return response.data;
};

export const fetchAffiliateCommissions = async (affiliateId, params = {}) => {
  const response = await api.get(`/admin/affiliate/partners/${affiliateId}/commissions/`, { params });
  return response.data;
};

// Disbursement API functions
export const manualDisburseFunds = async () => {
  const response = await api.post('/admin/affiliate/disburse/manual/');
  return response.data;
};

export const toggleAutoDisburse = async (enabled) => {
  const response = await api.post('/admin/affiliate/disburse/toggle-auto/', { enabled });
  return response.data;
};

export const getDisburseStatus = async () => {
  const response = await api.get('/admin/affiliate/disburse/status/');
  return response.data;
};

export const fetchAffiliateReferrals = async (params = {}) => {
  const response = await api.get('/admin/affiliate/referrals/', { params });
  return response.data;
};

export const searchAffiliateForManualLink = async (query) => {
  const response = await api.get('/admin/affiliate/manual-link/search-affiliate/', {
    params: { q: query },
  });
  return response.data;
};

export const searchUserForManualAffiliateLink = async (query) => {
  const response = await api.get('/admin/affiliate/manual-link/search-user/', {
    params: { q: query },
  });
  return response.data;
};

export const manuallyLinkAffiliateUser = async ({ affiliateId, userId }) => {
  const response = await api.post('/admin/affiliate/manual-link/', {
    affiliate_id: affiliateId,
    user_id: userId,
  });
  return response.data;
};


